var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.99548H8C6.9 2.99548 6 3.89548 6 4.99548V16.9955C6 18.0955 6.9 18.9955 8 18.9955H20C21.1 18.9955 22 18.0955 22 16.9955V4.99548C22 3.89548 21.1 2.99548 20 2.99548ZM20 16.9955H8V4.99548H20V16.9955ZM4 6.99548H2V20.9955C2 22.0955 2.9 22.9955 4 22.9955H18V20.9955H4V6.99548ZM16 12.9955V9.99548C16 9.44548 15.55 8.99548 15 8.99548H13V13.9955H15C15.55 13.9955 16 13.5455 16 12.9955ZM14 9.99548H15V12.9955H14V9.99548ZM18 11.9955H19V10.9955H18V9.99548H19V8.99548H17V13.9955H18V11.9955ZM10 11.9955H11C11.55 11.9955 12 11.5455 12 10.9955V9.99548C12 9.44548 11.55 8.99548 11 8.99548H9V13.9955H10V11.9955ZM10 9.99548H11V10.9955H10V9.99548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.2d8b7dd6fc3b05d5de9faffad33f7be2.svg";
export { ForwardRef as ReactComponent };